import { formatDate, formatDateTime, formatDuration, formatElevation } from "../lib/format";
import { useT } from "../lib/i18n";

export type TooltipState = { x: number; y: number; feature: Record<string, unknown> };

export function MapTooltip({ tooltip }: { tooltip: TooltipState | null }) {
  const { t, labelizeT } = useT();
  if (!tooltip) return null;
  const f = tooltip.feature;
  const kind = String(f.kind ?? "");

  return (
    <div
      className="pointer-events-none absolute z-20 max-w-60 -translate-x-1/2 rounded-xl bg-slate-900/90 px-3.5 py-2.5 text-white shadow-pop backdrop-blur-sm"
      style={{ left: tooltip.x, top: tooltip.y - 12, transform: "translate(-50%, -100%)" }}
    >
      <p className="text-[10px] font-semibold uppercase tracking-wider text-slate-400">{kind ? labelizeT(kind) : kind}</p>
      <p className="text-sm font-semibold">{String(f.name ?? "")}</p>
      <p className="mt-0.5 text-xs text-slate-300">
        {kind === "place" && `${labelizeT(String(f.type ?? ""))} · ${formatElevation(f.elevation as number | null)}`}
        {kind === "route" &&
          `${String(f.activities ?? "")
            .split(", ")
            .filter(Boolean)
            .map(labelizeT)
            .join(", ")}${f.durationMin ? ` · ${formatDuration(f.durationMin as number)}` : ""}`}
        {kind === "outing" && `${labelizeT(String(f.activity ?? ""))} · ${formatDate(String(f.date ?? ""))}`}
        {kind === "region" && labelizeT(String(f.type ?? ""))}
        {kind === "event" && formatDateTime(f.startsAt as string | undefined)}
      </p>
      <p className="mt-1.5 text-[10px] text-slate-400">{t("tooltip.clickForDetails")}</p>
    </div>
  );
}
